import { Navbar } from './Navbar';
import { Footer } from './Footer';
import { HotOfferBanner } from './HotOfferBanner';

export const Layout = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col bg-background">
      <HotOfferBanner />
      <Navbar />
      <main
        id="main-content"
        className="flex-1"
        style={{ paddingTop: '92px' }}
        tabIndex={-1}
      >
        {children}
      </main>
      <Footer />
    </div>
  );
};

export default Layout;
